// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminReviewsForm-commonHeaderAdmin-zRyMW {
	position: fixed !important;
}

.AdminReviewsForm-adminLayout-lr8xj {
	padding-top: 64px !important;
}

.AdminReviewsForm-box-ei6rg h2 {
	font-size: 21px;
	font-weight: 600;
}

.AdminReviewsForm-exportLink-YiZ2K {
	margin-bottom: -29px;
}

.AdminReviewsForm-blockCenter-jj8ZU {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.AdminReviewsForm-panelHeader-S5cfa {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.AdminReviewsForm-currencyselect-N7bMT {
	width: 100%;
	margin-right: 0px;
}

.AdminReviewsForm-panelHeader-S5cfa {
	overflow: hidden;
	position: relative;
}

.AdminReviewsForm-mar0-QVZkq {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.AdminReviewsForm-blockCenter-jj8ZU {
		padding: 0px;
	}

	.AdminReviewsForm-panelHeader-S5cfa {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.AdminReviewsForm-sideAdminPageWrapper-NAAcl {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.AdminReviewsForm-panelHeader-S5cfa {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.AdminReviewsForm-table-zwXJg {
	display: table;
}

.AdminReviewsForm-tableRow-OEJEj {
	display: table-row;
}

.AdminReviewsForm-tableCell-OhQei {
	display: table-cell;
	float: none;
}

.AdminReviewsForm-formGroup-cv1MB {
	margin-bottom: 6px;
}

.AdminReviewsForm-select-Q0hJq {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.AdminReviewsForm-noMargin-S5KtH {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.AdminReviewsForm-exportLink-YiZ2K {
	padding-top: 10px;
	padding-right: 10px;
}

.AdminReviewsForm-labelTextNew-Jbz5M {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.AdminReviewsForm-displayInline-obZfH {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.AdminReviewsForm-btnUPdate-ArMcP {
	display: inline-block;
}

.AdminReviewsForm-btnModalDelete-SdW2C {
	display: inline-block;
	margin-left: 15px;
}

.AdminReviewsForm-radioBtn-kbAd2 {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.AdminReviewsForm-backgroundImg-y_aQx {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.AdminReviewsForm-btnUPdate-ArMcP {
		display: block;
		margin-bottom: 12px;
	}

	.AdminReviewsForm-btnModalDelete-SdW2C {
		display: block;
		margin-left: 0px;
	}

	.AdminReviewsForm-btnWidth-WaTxQ {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.AdminReviewsForm-bannerImageBg-Qyms7 {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.AdminReviewsForm-bannerDelete-GzRVH {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.AdminReviewsForm-modalRoot-Tr9ke {
	padding: 32px;
}

.AdminReviewsForm-modalBorderBottom-aLuP5 {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.AdminReviewsForm-logInModalBody-dulHe {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.AdminReviewsForm-exportSection-YBJtE {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.AdminReviewsForm-exportSectionGridSub-V31AM {
	grid-template-columns: 50% 49% !important;
}

.AdminReviewsForm-exportText-aj_sc {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.AdminReviewsForm-exportLinkImg-WN84w {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.AdminReviewsForm-vtrMiddle-VEIQM {
	vertical-align: middle;
}

.AdminReviewsForm-exportImg-Iqqz4 {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.AdminReviewsForm-profileViewlabel-XQqrd {
	display: inline-block;
	width: 38%
}

.AdminReviewsForm-profileViewMainContent-C2Akm {
	display: inline-block;
	width: 62%;
}

.AdminReviewsForm-profileViewMain-PA4Tn {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.AdminReviewsForm-profileViewInner-lT1r0 {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.AdminReviewsForm-profileImageSection-XWL41 {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.AdminReviewsForm-lastviewInner-QyY_7 {
	padding: 10px;
}

.AdminReviewsForm-whyHostHoriLine-FaoCx {
	margin: 30px 0;
}

.AdminReviewsForm-tableGrid-Z5r6B {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.AdminReviewsForm-headingContent-SWkbR {
	font-size: 18px;
	font-weight: 500;
}

.AdminReviewsForm-refundTextColor-rbPbk {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.AdminReviewsForm-dividerLine-SvMDz {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.AdminReviewsForm-smallContent-K7Eev {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.AdminReviewsForm-sideAdminPageWrapper-NAAcl {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.AdminReviewsForm-sideAdminPageWrapper-NAAcl {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.AdminReviewsForm-exportSection-YBJtE {
		grid-template-columns: 100%;
	}

	.AdminReviewsForm-exportSectionGridSub-V31AM {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.AdminReviewsForm-profileViewlabel-XQqrd {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.AdminReviewsForm-profileViewMainContent-C2Akm {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.AdminReviewsForm-ChangeToUpperCase-M3m3f {
	text-transform: uppercase
}

.AdminReviewsForm-noBorder-vh7pu {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.AdminReviewsForm-siteAdminHeading-xC8Aa {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.AdminReviewsForm-siteAdminSubHeading-hDigF {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.AdminReviewsForm-adminFormDivider-JFQMD {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.AdminReviewsForm-errorMessage-WRary {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.AdminReviewsForm-panelHeader-S5cfa {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.AdminReviewsForm-formGroup-cv1MB {
  margin-bottom: 6px;
}

.AdminReviewsForm-select-Q0hJq {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.AdminReviewsForm-labelText-cFg98 {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.AdminReviewsForm-space1-pyzkC {
	margin-bottom: 6px !important;
}

.AdminReviewsForm-space2-GYM4x {
	margin-bottom: 12px !important;
}

.AdminReviewsForm-space3-fEHw7 {
	margin-bottom: 18px !important;
}

.AdminReviewsForm-space4-C0XmM {
	margin-bottom: 24px !important;
}

.AdminReviewsForm-space5-aHPh6 {
	margin-bottom: 30px !important;
}

.AdminReviewsForm-space6-P8Jmz {
	margin-bottom: 36px !important;
}

.AdminReviewsForm-space7-JKMGc {
	margin-bottom: 42px !important;
}

.AdminReviewsForm-spaceTop8-tQJyj {
	margin-bottom: 48px !important;
}

.AdminReviewsForm-spaceTop1-HiGfJ {
	margin-top: 6px !important;
}

.AdminReviewsForm-spaceTop2-CAiMa {
	margin-top: 12px !important;
}

.AdminReviewsForm-spaceTop3-EQ1de {
	margin-top: 18px !important;
}

.AdminReviewsForm-spaceTop4-Ms_eO {
	margin-top: 24px !important;
}

.AdminReviewsForm-spaceTop5-EL4qG {
	margin-top: 30px !important;
}

.AdminReviewsForm-spaceTop6-GGorB {
	margin-top: 36px !important;
}

.AdminReviewsForm-spaceTop7-xtWeS {
	margin-top: 42px !important;
}

.AdminReviewsForm-spaceTop8-tQJyj {
	margin-top: 48px !important;
}

.AdminReviewsForm-noMargin-S5KtH {
	margin: 0px !important;
}

.AdminReviewsForm-padding1-S5_ro {
	padding-bottom: 6px !important;
}

.AdminReviewsForm-padding2-ib6F8 {
	padding-bottom: 12px !important;
}

.AdminReviewsForm-padding3-lrLLE {
	padding-bottom: 18px !important;
}

.AdminReviewsForm-padding4-A9oir {
	padding-bottom: 24px !important;
}

.AdminReviewsForm-padding5-sPnAz {
	padding-bottom: 30px !important;
}

.AdminReviewsForm-padding6-fHkK7 {
	padding-bottom: 36px !important;
}

.AdminReviewsForm-padding7-C8O7h {
	padding-bottom: 42px !important;
}

.AdminReviewsForm-paddingTop1-Ax1jR {
	padding-top: 6px !important;
}

.AdminReviewsForm-paddingTop2-b7jYF {
	padding-top: 12px !important;
}

.AdminReviewsForm-paddingTop3-PNyJt {
	padding-top: 18px !important;
}

.AdminReviewsForm-paddingTop4-so5vE {
	padding-top: 24px !important;
}

.AdminReviewsForm-paddingTop5-MrR6e {
	padding-top: 30px !important;
}

.AdminReviewsForm-paddingTop6-X10Z9 {
	padding-top: 36px !important;
}

.AdminReviewsForm-paddingTop7-_ar4w {
	padding-top: 42px !important;
}

.AdminReviewsForm-noPadding-CNgjy {
	padding: 0px !important;
}

.AdminReviewsForm-textBold-KBBa6 {
	font-weight: 500 !important;
}

.AdminReviewsForm-textBolder-nYmfH {
	font-weight: 700 !important;
}

.AdminReviewsForm-textNormal-Wm66Z {
	font-weight: normal !important;
}

.AdminReviewsForm-spaceBottom20-hqPL9 {
	margin-bottom: 20px;
}

.AdminReviewsForm-spaceBottom10-mtGyR {
	margin-bottom: 10px;
}

.AdminReviewsForm-marginNone-OQ2WD {
	margin: 0;
}

.AdminReviewsForm-spaceBottom15-STRu1 {
	margin-bottom: 15px;
}

.AdminReviewsForm-marginTopNone-B_fry {
	margin-top: 0;
}

.AdminReviewsForm-spaceTop11-rtJZ_ {
	margin-top: 11px;
}

.AdminReviewsForm-spaceTop21-d30Ht {
	margin-top: 21px;
}

.AdminReviewsForm-spaceTop20-ig7Fw {
	margin-top: 20px;
}

.AdminReviewsForm-spaceTop10-tP8U7 {
	margin-top: 10px;
}

/*New Design Text Colors */

.AdminReviewsForm-textDarkBlue-G8v4R {
	color: rgb(20, 39, 94) !important;
}

.AdminReviewsForm-textLightBlue-AX7Ag {
	color: rgb(57, 87, 106) !important;
}

.AdminReviewsForm-textLightSandleGreen-PYS5o {
	color: rgb(76, 86, 41) !important;
}

.AdminReviewsForm-textLightBrown-qcfY9 {
	color: rgb(115, 79, 33) !important;
}

.AdminReviewsForm-textMediumMaroon-EMxbk {
	color: rgb(87, 37, 51) !important;
}

.AdminReviewsForm-textBrown-kMAwJ {
	color: rgb(160, 47, 24) !important;
}

.AdminReviewsForm-textMaroon-n039p {
	color: rgb(155, 49, 67) !important;
}

.AdminReviewsForm-textDarkBrown-guwch {
	color: rgb(83, 18, 16) !important;
}

.AdminReviewsForm-textMediumBrown-OdlUv {
	color: rgb(142, 28, 10) !important;
}

.AdminReviewsForm-textSkyBlue-WLMpX {
	color: rgb(37, 117, 141) !important;
}

.AdminReviewsForm-textGray-s6b9m {
	color: rgb(77, 65, 51) !important;
}

.AdminReviewsForm-adminReviewStar-GYvBt svg {
    font-size: 32px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/AdminReviewsForm/AdminReviewsForm.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;ACxNA;IACI,eAAe;IACf,eAAe;AACnB","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../admin-common.css';\n@import '../admin-form.css';\n@import '../../helpers.css';\n\n.adminReviewStar svg {\n    font-size: 32px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `AdminReviewsForm-commonHeaderAdmin-zRyMW`,
	"adminLayout": `AdminReviewsForm-adminLayout-lr8xj`,
	"box": `AdminReviewsForm-box-ei6rg`,
	"exportLink": `AdminReviewsForm-exportLink-YiZ2K`,
	"blockCenter": `AdminReviewsForm-blockCenter-jj8ZU`,
	"panelHeader": `AdminReviewsForm-panelHeader-S5cfa`,
	"currencyselect": `AdminReviewsForm-currencyselect-N7bMT`,
	"mar0": `AdminReviewsForm-mar0-QVZkq`,
	"sideAdminPageWrapper": `AdminReviewsForm-sideAdminPageWrapper-NAAcl`,
	"table": `AdminReviewsForm-table-zwXJg`,
	"tableRow": `AdminReviewsForm-tableRow-OEJEj`,
	"tableCell": `AdminReviewsForm-tableCell-OhQei`,
	"formGroup": `AdminReviewsForm-formGroup-cv1MB`,
	"select": `AdminReviewsForm-select-Q0hJq`,
	"noMargin": `AdminReviewsForm-noMargin-S5KtH`,
	"labelTextNew": `AdminReviewsForm-labelTextNew-Jbz5M`,
	"displayInline": `AdminReviewsForm-displayInline-obZfH`,
	"btnUPdate": `AdminReviewsForm-btnUPdate-ArMcP`,
	"btnModalDelete": `AdminReviewsForm-btnModalDelete-SdW2C`,
	"radioBtn": `AdminReviewsForm-radioBtn-kbAd2`,
	"backgroundImg": `AdminReviewsForm-backgroundImg-y_aQx`,
	"btnWidth": `AdminReviewsForm-btnWidth-WaTxQ`,
	"bannerImageBg": `AdminReviewsForm-bannerImageBg-Qyms7`,
	"bannerDelete": `AdminReviewsForm-bannerDelete-GzRVH`,
	"modalRoot": `AdminReviewsForm-modalRoot-Tr9ke`,
	"modalBorderBottom": `AdminReviewsForm-modalBorderBottom-aLuP5`,
	"logInModalBody": `AdminReviewsForm-logInModalBody-dulHe`,
	"exportSection": `AdminReviewsForm-exportSection-YBJtE`,
	"exportSectionGridSub": `AdminReviewsForm-exportSectionGridSub-V31AM`,
	"exportText": `AdminReviewsForm-exportText-aj_sc`,
	"exportLinkImg": `AdminReviewsForm-exportLinkImg-WN84w`,
	"vtrMiddle": `AdminReviewsForm-vtrMiddle-VEIQM`,
	"exportImg": `AdminReviewsForm-exportImg-Iqqz4`,
	"profileViewlabel": `AdminReviewsForm-profileViewlabel-XQqrd`,
	"profileViewMainContent": `AdminReviewsForm-profileViewMainContent-C2Akm`,
	"profileViewMain": `AdminReviewsForm-profileViewMain-PA4Tn`,
	"profileViewInner": `AdminReviewsForm-profileViewInner-lT1r0`,
	"profileImageSection": `AdminReviewsForm-profileImageSection-XWL41`,
	"lastviewInner": `AdminReviewsForm-lastviewInner-QyY_7`,
	"whyHostHoriLine": `AdminReviewsForm-whyHostHoriLine-FaoCx`,
	"tableGrid": `AdminReviewsForm-tableGrid-Z5r6B`,
	"headingContent": `AdminReviewsForm-headingContent-SWkbR`,
	"refundTextColor": `AdminReviewsForm-refundTextColor-rbPbk`,
	"dividerLine": `AdminReviewsForm-dividerLine-SvMDz`,
	"smallContent": `AdminReviewsForm-smallContent-K7Eev`,
	"ChangeToUpperCase": `AdminReviewsForm-ChangeToUpperCase-M3m3f`,
	"noBorder": `AdminReviewsForm-noBorder-vh7pu`,
	"siteAdminHeading": `AdminReviewsForm-siteAdminHeading-xC8Aa`,
	"siteAdminSubHeading": `AdminReviewsForm-siteAdminSubHeading-hDigF`,
	"adminFormDivider": `AdminReviewsForm-adminFormDivider-JFQMD`,
	"errorMessage": `AdminReviewsForm-errorMessage-WRary`,
	"labelText": `AdminReviewsForm-labelText-cFg98`,
	"space1": `AdminReviewsForm-space1-pyzkC`,
	"space2": `AdminReviewsForm-space2-GYM4x`,
	"space3": `AdminReviewsForm-space3-fEHw7`,
	"space4": `AdminReviewsForm-space4-C0XmM`,
	"space5": `AdminReviewsForm-space5-aHPh6`,
	"space6": `AdminReviewsForm-space6-P8Jmz`,
	"space7": `AdminReviewsForm-space7-JKMGc`,
	"spaceTop8": `AdminReviewsForm-spaceTop8-tQJyj`,
	"spaceTop1": `AdminReviewsForm-spaceTop1-HiGfJ`,
	"spaceTop2": `AdminReviewsForm-spaceTop2-CAiMa`,
	"spaceTop3": `AdminReviewsForm-spaceTop3-EQ1de`,
	"spaceTop4": `AdminReviewsForm-spaceTop4-Ms_eO`,
	"spaceTop5": `AdminReviewsForm-spaceTop5-EL4qG`,
	"spaceTop6": `AdminReviewsForm-spaceTop6-GGorB`,
	"spaceTop7": `AdminReviewsForm-spaceTop7-xtWeS`,
	"padding1": `AdminReviewsForm-padding1-S5_ro`,
	"padding2": `AdminReviewsForm-padding2-ib6F8`,
	"padding3": `AdminReviewsForm-padding3-lrLLE`,
	"padding4": `AdminReviewsForm-padding4-A9oir`,
	"padding5": `AdminReviewsForm-padding5-sPnAz`,
	"padding6": `AdminReviewsForm-padding6-fHkK7`,
	"padding7": `AdminReviewsForm-padding7-C8O7h`,
	"paddingTop1": `AdminReviewsForm-paddingTop1-Ax1jR`,
	"paddingTop2": `AdminReviewsForm-paddingTop2-b7jYF`,
	"paddingTop3": `AdminReviewsForm-paddingTop3-PNyJt`,
	"paddingTop4": `AdminReviewsForm-paddingTop4-so5vE`,
	"paddingTop5": `AdminReviewsForm-paddingTop5-MrR6e`,
	"paddingTop6": `AdminReviewsForm-paddingTop6-X10Z9`,
	"paddingTop7": `AdminReviewsForm-paddingTop7-_ar4w`,
	"noPadding": `AdminReviewsForm-noPadding-CNgjy`,
	"textBold": `AdminReviewsForm-textBold-KBBa6`,
	"textBolder": `AdminReviewsForm-textBolder-nYmfH`,
	"textNormal": `AdminReviewsForm-textNormal-Wm66Z`,
	"spaceBottom20": `AdminReviewsForm-spaceBottom20-hqPL9`,
	"spaceBottom10": `AdminReviewsForm-spaceBottom10-mtGyR`,
	"marginNone": `AdminReviewsForm-marginNone-OQ2WD`,
	"spaceBottom15": `AdminReviewsForm-spaceBottom15-STRu1`,
	"marginTopNone": `AdminReviewsForm-marginTopNone-B_fry`,
	"spaceTop11": `AdminReviewsForm-spaceTop11-rtJZ_`,
	"spaceTop21": `AdminReviewsForm-spaceTop21-d30Ht`,
	"spaceTop20": `AdminReviewsForm-spaceTop20-ig7Fw`,
	"spaceTop10": `AdminReviewsForm-spaceTop10-tP8U7`,
	"textDarkBlue": `AdminReviewsForm-textDarkBlue-G8v4R`,
	"textLightBlue": `AdminReviewsForm-textLightBlue-AX7Ag`,
	"textLightSandleGreen": `AdminReviewsForm-textLightSandleGreen-PYS5o`,
	"textLightBrown": `AdminReviewsForm-textLightBrown-qcfY9`,
	"textMediumMaroon": `AdminReviewsForm-textMediumMaroon-EMxbk`,
	"textBrown": `AdminReviewsForm-textBrown-kMAwJ`,
	"textMaroon": `AdminReviewsForm-textMaroon-n039p`,
	"textDarkBrown": `AdminReviewsForm-textDarkBrown-guwch`,
	"textMediumBrown": `AdminReviewsForm-textMediumBrown-OdlUv`,
	"textSkyBlue": `AdminReviewsForm-textSkyBlue-WLMpX`,
	"textGray": `AdminReviewsForm-textGray-s6b9m`,
	"adminReviewStar": `AdminReviewsForm-adminReviewStar-GYvBt`
};
module.exports = ___CSS_LOADER_EXPORT___;
